import React, { Fragment, useState, useRef } from "react";
import MessageIcon from '@mui/icons-material/Message';
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import moment from "moment-timezone";

import "./RequestTable.css";


const CustomMessagePopup = (props) => {
    return (<Popup id="popup"
        visible={props.visible}
        closeOnOutsideClick={false}

        onHiding={() => props.popupHandler(!props.visible)}
        title={props.title}
        showTitle={true}
        // contentRender={PatientList}
        resizeEnabled={true}
        width={props.width}
        height={props.height}
    >
        {props.children}

    </Popup>)
}

const DisplayMessage = (props) => {
    return <textarea value={props.message} style={{ width: "100%", height: "90%" }} />
}

const DisplayEmail = (props) => {
    return <div style={{ width: "100%" }} dangerouslySetInnerHTML={{__html:props.message}} >{}</div>
}



const RequestTable = ({ requestLog,server_timezone,center_timezone }) => {
    const [message, setMessage] = useState("")
    const [showMessageTest, setShowMessageText] = useState(false)
    const [uniqueId, setUniqueId] = useState(null)

    // console.log("requestLog", requestLog);
    const message_type = useRef(null);
    const messageHandler = (message_content, id, type) => {
        const replacedContent = message_content.replace('cid:vengage-logo',"/assets/images/vengage_logo.png");
        message_type.current = type;
        setMessage(replacedContent)
        setShowMessageText(true)
        setUniqueId(id)
        

    }
    const convertServerTimeIntoLocalTime=(initiate_time,server_timezone,center_timezone)=>{
        if(server_timezone && center_timezone && initiate_time){
            const momentServer = moment.tz(initiate_time, server_timezone);
        // Convert to target timezone
        const momentTarget = momentServer.clone().tz(center_timezone);
        // Format the result as required
        const formattedTime = momentTarget.format('DD/MM/yyyy h:mm a').toUpperCase();
        return formattedTime;
        }else{
            return initiate_time
        }
        
    }
    return (
        <Fragment>
            {message_type.current==="SMS" && <CustomMessagePopup width="30%" height="300" visible={showMessageTest} popupHandler={() => setShowMessageText(!showMessageTest)}>
                <DisplayMessage showMessageTest={showMessageTest} message={message} />
            </CustomMessagePopup>}
            {message_type.current==="EMAIL" && <CustomMessagePopup visible={showMessageTest} popupHandler={() => setShowMessageText(!showMessageTest)}>
                <DisplayEmail  showMessageTest={showMessageTest} message={message} ></DisplayEmail>
                {/* <span dangerouslySetInnerHTML={{_html: message}}></span> */}
                {/* <DisplayMessage showMessageTest={showMessageTest} message={message} /> */}
            </CustomMessagePopup>}
            <div>
                <div className="gridTable">
                    <div className="date">Date / Time</div>
                    <div className="sentOn">Type</div>
                    <div className="MessageStatus">Status</div>
                    <div className="context">Details</div>
                    <div className="Message"> </div>
                </div>

                <div className="data">
                    {requestLog.map((item, index) => {
                        const formattedDateTimeInDisplayFormat = moment(moment(`${item.date} ${item.time}`, 'YYYY-MM-DD HH:mm')).format("DD/MM/yyyy h:mm a").toUpperCase()
                        const formattedDateTimeInStandardFormat = moment(moment(`${item.date} ${item.time}`, 'YYYY-MM-DD HH:mm')).format("YYYY-MM-DDTHH:mm").toUpperCase()
                        const center_time = convertServerTimeIntoLocalTime(formattedDateTimeInStandardFormat,server_timezone,center_timezone)
                        let smsDeliveredTime = ''
                        if (item.sent_on === 'SMS' && item.status === 'DELIVERED' && item.delivered_time) {
                            smsDeliveredTime = `Delivered On: ${moment(item.delivered_time).format("DD/MM/yyyy h:mm a").toUpperCase()}`
                        }
                          
                        return (
                            <div key={index}>
                                <div className="tableData" style={{ background: uniqueId == item.time && "lightgrey" }}>
                                    <div className="tableDate" style={{display:"grid"}}>
                                     <div>{formattedDateTimeInDisplayFormat}</div>   
                                   {formattedDateTimeInDisplayFormat!=center_time &&  <div>{center_time} (local)</div>  } 
                                        </div>
                                    <div className="tableSentOn">{item.sent_on} </div>
                                    <div className="tableStatus" 
                                    style={{color:item.status==='BOUNCED' || item.status==='FAILED'|| item.status==='MARKED_AS_SPAM' || item.status==='SENDER_BLOCKED' || item.status==='IN-TRANSIT'?"red":""}}
                                    >{item.status} </div>
                                    {item.sent_on == 'SMS' && smsDeliveredTime !== '' && <div className="tableContext">{item.context} <br/> {smsDeliveredTime} </div>}
                                    {item.sent_on == 'SMS' && smsDeliveredTime === '' && <div className="tableContext">{item.context} </div>}
                                    {item.sent_on == 'EMAIL' && <div className="tableContext">{item.context} <br/> {item.receiver} </div>}
                                    <div className="tableMessageIcon"> <MessageIcon className="messageIcon" style={{ marginRight: "5px" }} onClick={() => messageHandler(item.message_content, item.time, item.sent_on)} /></div>

                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Fragment>
    );
};

export default RequestTable;
